/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Active_TitleInputs */

const en_agent_authorization_active_title = /** @type {(inputs: Agent_Authorization_Active_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project access approved`)
};

const zh_agent_authorization_active_title = /** @type {(inputs: Agent_Authorization_Active_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已批准项目访问`)
};

/**
* | output |
* | --- |
* | "Project access approved" |
*
* @param {Agent_Authorization_Active_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_active_title = /** @type {((inputs?: Agent_Authorization_Active_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Active_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_active_title(inputs)
	return zh_agent_authorization_active_title(inputs)
});
export { agent_authorization_active_title as "agent.authorization.active_title" }